import { Ban, Trash2, UserCheck, UserMinus } from 'lucide-react';
import { Stat } from '@/client/components/common/StatsGrid';
import type { AdminUserSummary } from '@/client/types/admin/users-orgs';

/** One tile per status bucket; clicking a tile filters the list to it. */
export function buildAccountStats(summary: AdminUserSummary | undefined): Stat[] {
  const total = summary?.total_users ?? 0;
  const counts = summary?.status_counts;
  const share = (n?: number) =>
    total > 0 && n !== undefined ? `${((n / total) * 100).toFixed(1)}% of ${total.toLocaleString()}` : undefined;

  return [
    { key: 'active', label: 'Active', value: counts?.active, hint: share(counts?.active), icon: UserCheck, tone: 'bg-emerald-50 text-emerald-600' },
    { key: 'suspended', label: 'Suspended', value: counts?.suspended, hint: share(counts?.suspended), icon: Ban, tone: 'bg-red-50 text-red-600' },
    { key: 'inactive', label: 'Inactive', value: counts?.inactive, hint: share(counts?.inactive), icon: UserMinus, tone: 'bg-gray-100 text-gray-600' },
    { key: 'deleted', label: 'Deleted', value: counts?.deleted, hint: share(counts?.deleted), icon: Trash2, tone: 'bg-gray-100 text-gray-700' },
  ];
}
